import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {PicklistDetailDto} from "../../api/fms";
import {growlStore} from "../GrowlStore";

class FmsPicklistDetailStore {
    get downloading(): boolean {
        return this._downloading;
    }

    set downloading(value: boolean) {
        this._downloading = value;
    }

    get executing(): boolean {
        return this._executing;
    }

    set executing(value: boolean) {
        this._executing = value;
    }

    get data(): PicklistDetailDto | undefined {
        return this._data;
    }

    private set data(value: PicklistDetailDto | undefined) {
        this._data = value;
    }

    get loading(): boolean {
        return this._loading;
    }

    private set loading(value: boolean) {
        this._loading = value;
    }

    get id(): string {
        return this._id;
    }

    private set id(value: string) {
        this._id = value;
    }

    get hasScanItem(): boolean {
        if (!this.data?.items) {
            return false
        }
        const found = this.data?.items.find(e => !e.lastScan)

        return found !== undefined
    }

    private _id: string = ''
    private _loading: boolean = false
    private _downloading: boolean = false
    private _executing: boolean = false
    private _data: PicklistDetailDto | undefined

    constructor() {
        makeAutoObservable(this)
    }

    async load(id: string) {
        this.id = id
        return await this.reload()
    }

    async reload() {
        this.loading = true

        const {id} = this

        const result = await catchApi(async () => await api.fms.api.getPicklistDetail(id))

        const data = result?.data
        this.data = data

        this.loading = false

        return data
    }

    async print(printerId: string) {
        const {id} = this
        this.loading = true
        await api.fms.api.printPicklist(
            id,
            {
                printerId
            }
        )
    }

    documentIdByVin(vin: string): string | undefined {
        const items = this.data?.items || []
        const found = items.find((s) => s.vin === vin && !s.lastScan)
        return found?.documentId
    }

    async lastScan(documentId: string) {

        const items = this.data?.items || []
        const found = items.find((s) => s.documentId === documentId)
        const itemId = found?.id
        if (!itemId) {
            growlStore.add({
                message: `Dokument mit id '${documentId}' nicht gefunden`,
                autoclose: false,
                closable: true,
                cls: 'is-danger'
            })
            return
        }


        this.loading = true
        const {id} = this
        const result = await catchApi(async () => await api.fms.api.lastScan(id, itemId))

        const data = result?.data
        if (data) {
            this.data = data
            growlStore.add({
                message: "Last scan abgeschlossen",
                autoclose: 2000
            })
        }

        this.loading = false
    }
}

const fmsPicklistDetailStore = new FmsPicklistDetailStore()

export {
    fmsPicklistDetailStore
}
